(function () {
  const SELECTOR = '[data-sc-test-offer]';

  function selectedPurchaseType(section) {
    return section.querySelector('[data-sc-purchase-toggle] input:checked')?.value || 'subscription';
  }

  function selectedCatCount(section) {
    if (selectedPurchaseType(section) !== 'subscription') return 1;
    return Math.max(1, Math.min(3, Number(section.querySelector('[data-sc-cat-selector] input:checked')?.value) || 1));
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format((Number(cents) || 0) / 100);
  }

  function updateCard(card, purchaseType, catCount) {
    const subscription = purchaseType === 'subscription';
    const subscriptionImage = card.querySelector('[data-sc-subscription-image]');
    const oneTimeImage = card.querySelector('[data-sc-one-time-image]');
    if (subscriptionImage) {
      subscriptionImage.hidden = !subscription;
      subscriptionImage.style.display = subscription ? '' : 'none';
    }
    if (oneTimeImage) {
      oneTimeImage.hidden = subscription;
      oneTimeImage.style.display = subscription ? 'none' : 'flex';
    }
    const price = subscription ? card.dataset.subscriptionPrice : card.dataset.oneTimePrice;
    const perBox = subscription ? card.dataset.subscriptionPerBoxFormatted : card.dataset.oneTimePerBoxFormatted;
    const savings = subscription ? card.dataset.subscriptionSavings : card.dataset.oneTimeSavings;
    const compare = Number(card.dataset.comparePrice || 0);
    const priceNode = card.querySelector('[data-sc-price]');
    const perBoxNode = card.querySelector('[data-sc-per-box]');
    const compareNode = card.querySelector('[data-sc-compare-price]');
    const saveNode = card.querySelector('[data-sc-save]');
    const multiCatSummary = card.querySelector('[data-sc-multi-cat-summary]');
    const buyButton = card.querySelector('[data-sc-buy]');
    const totalBoxes = Number(card.dataset.boxCount || 1) * catCount;

    if (priceNode) priceNode.textContent = formatMoney(Number(price || 0) * catCount);
    if (perBoxNode) perBoxNode.textContent = perBox;
    if (compareNode) {
      compareNode.textContent = formatMoney(compare * catCount);
      compareNode.hidden = Number(savings || 0) <= 0;
    }
    if (saveNode) {
      saveNode.textContent = `Save ${savings}%`;
      saveNode.hidden = Number(savings || 0) <= 0;
    }
    if (multiCatSummary) {
      multiCatSummary.textContent = `${catCount} cats · ${totalBoxes} ${totalBoxes === 1 ? 'box' : 'boxes'} total per delivery`;
      multiCatSummary.hidden = !subscription || catCount === 1;
    }
    if (buyButton && !buyButton.disabled) {
      buyButton.textContent = subscription && catCount > 1 ? `Buy for ${catCount} Cats` : 'Buy Now';
    }
  }

  function updateSection(section) {
    const purchaseType = selectedPurchaseType(section);
    const subscription = purchaseType === 'subscription';
    section.querySelectorAll('[data-sc-purchase-toggle] label').forEach((label) => {
      label.classList.toggle('is-selected', Boolean(label.querySelector('input:checked')));
    });
    const catCount = selectedCatCount(section);
    const catSelector = section.querySelector('[data-sc-cat-selector]');
    if (catSelector) catSelector.hidden = !subscription;
    section.querySelectorAll('[data-sc-cat-selector] label').forEach((label) => {
      label.classList.toggle('is-selected', Boolean(label.querySelector('input:checked')));
    });
    section.querySelectorAll('[data-sc-offer-card]').forEach((card) => updateCard(card, purchaseType, catCount));
    section.querySelectorAll('[data-sc-delivery]').forEach((delivery) => {
      delivery.hidden = !subscription;
    });
    const note = section.querySelector('[data-sc-subscription-note]');
    if (note) note.hidden = !subscription;
  }

  function setEstimatedShipDate(section) {
    const node = section.querySelector('[data-sc-ship-date]');
    if (node) node.textContent = 'tomorrow';
  }

  function updateShippingCountdown(section) {
    const timer = section.querySelector('[data-sc-shipping-countdown]');
    const desktopTimer = section.querySelector('[data-sc-desktop-countdown]');
    if (!timer && !desktopTimer) return;

    const now = new Date();
    const cutoff = new Date(now);
    cutoff.setHours(24, 0, 0, 0);
    const remainingSeconds = Math.max(0, Math.floor((cutoff - now) / 1000));
    const hours = Math.floor(remainingSeconds / 3600);
    const minutes = Math.floor((remainingSeconds % 3600) / 60);
    const seconds = remainingSeconds % 60;
    const label = 'Ships tomorrow';
    const labelNode = timer?.querySelector('[data-sc-shipping-label]');
    const hoursNode = timer?.querySelector('[data-sc-countdown-hours]');
    const minutesNode = timer?.querySelector('[data-sc-countdown-minutes]');
    const secondsNode = timer?.querySelector('[data-sc-countdown-seconds]');

    if (labelNode) labelNode.textContent = label;
    if (hoursNode) hoursNode.textContent = String(hours).padStart(2, '0');
    if (minutesNode) minutesNode.textContent = String(minutes).padStart(2, '0');
    if (secondsNode) secondsNode.textContent = String(seconds).padStart(2, '0');
    if (desktopTimer) desktopTimer.textContent = `${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m ${String(seconds).padStart(2, '0')}s`;
    timer?.setAttribute('aria-label', `${label} if you order within ${hours} hours, ${minutes} minutes, and ${seconds} seconds.`);
  }

  function startShippingCountdown(section) {
    updateShippingCountdown(section);
    window.clearInterval(section.scShippingCountdownInterval);
    section.scShippingCountdownInterval = window.setInterval(() => updateShippingCountdown(section), 1000);
  }

  async function addOfferToCart(section, card, button) {
    const purchaseType = selectedPurchaseType(section);
    const boxes = Number(card.dataset.boxCount) || 1;
    const item = {
      id: Number(card.dataset.variantId),
      quantity: selectedCatCount(section),
      properties: {
        _sc_boxes: `${boxes} ${boxes === 1 ? 'Box' : 'Boxes'}`,
        _sc_delivery: purchaseType === 'subscription' ? `Ships every ${boxes * 30} days` : 'One-time purchase',
        _sc_compare_at_unit: String(Number(card.dataset.comparePrice) || 0)
      }
    };
    if (purchaseType === 'subscription' && card.dataset.sellingPlanId) {
      item.selling_plan = Number(card.dataset.sellingPlanId);
    }

    const status = section.querySelector('[data-sc-offer-status]');
    const originalLabel = button.textContent;
    button.disabled = true;
    button.textContent = 'Loading…';
    if (status) status.textContent = '';

    try {
      if (!window.SuperCatCart?.open) throw new Error('cart_drawer_unavailable');
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: [item] })
      });
      if (!response.ok) throw new Error('cart_add_failed');
      await window.SuperCatCart.open();
    } catch (error) {
      if (status) status.textContent = 'We could not update your cart. Please try again.';
    } finally {
      button.disabled = false;
      button.textContent = originalLabel;
    }
  }

  async function addTwoCatMonthlyToCart(section) {
    const params = new URLSearchParams(window.location.search);
    if (params.get('checkout') !== 'two-cats-monthly') return;

    const card = section.querySelector('[data-sc-offer-card][data-box-count="1"]');
    const variantId = Number(card?.dataset.variantId);
    const sellingPlanId = Number(section.dataset.planThirtyId);
    const status = section.querySelector('[data-sc-offer-status]');
    if (!variantId || !sellingPlanId) {
      if (status) status.textContent = 'We could not prepare this checkout. Please contact SuperCat Labs support.';
      return;
    }

    section.setAttribute('aria-busy', 'true');
    const root = window.Shopify?.routes?.root || '/';

    try {
      if (!window.SuperCatCart?.open) throw new Error('cart_drawer_unavailable');
      const cartResponse = await fetch(`${root}cart.js`, {
        headers: { Accept: 'application/json' }
      });
      if (!cartResponse.ok) throw new Error('cart_read_failed');
      const cart = await cartResponse.json();
      const offerVariantIds = new Set(
        Array.from(section.querySelectorAll('[data-sc-offer-card]')).map((offerCard) => Number(offerCard.dataset.variantId))
      );
      const updates = {};
      cart.items?.forEach((item) => {
        if (offerVariantIds.has(Number(item.variant_id))) updates[item.key] = 0;
      });

      if (Object.keys(updates).length > 0) {
        const updateResponse = await fetch(`${root}cart/update.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates })
        });
        if (!updateResponse.ok) throw new Error('cart_update_failed');
      }

      const addResponse = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 2, selling_plan: sellingPlanId }]
        })
      });
      if (!addResponse.ok) throw new Error('cart_add_failed');

      await window.SuperCatCart.open();
    } catch (error) {
      if (status) status.textContent = 'We could not update your cart. Please try again or contact SuperCat Labs support.';
    } finally {
      section.removeAttribute('aria-busy');
    }
  }

  function initSection(section) {
    if (section.dataset.scInitialized === 'true') return;
    section.dataset.scInitialized = 'true';
    setEstimatedShipDate(section);
    startShippingCountdown(section);

    const subscriptionsAvailable = section.dataset.subscriptionsAvailable === 'true';
    if (!subscriptionsAvailable) {
      const oneTime = section.querySelector('[data-sc-purchase-toggle] input[value="one-time"]');
      if (oneTime) oneTime.checked = true;
    }

    section.addEventListener('change', (event) => {
      if (event.target.matches('[data-sc-purchase-toggle] input, [data-sc-cat-selector] input')) updateSection(section);
    });

    section.addEventListener('click', (event) => {
      const button = event.target.closest('[data-sc-buy]');
      if (!button) return;
      const card = button.closest('[data-sc-offer-card]');
      if (card) addOfferToCart(section, card, button);
    });

    updateSection(section);
    addTwoCatMonthlyToCart(section);
  }

  function initAll(root) {
    root.querySelectorAll(SELECTOR).forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', () => initAll(document));
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
